import { combineReducers } from 'redux';
import authenticationReducer from './AuthenticationReducer';
import subscriberReducer from './SubscriberReducer';
import contentLibraryReducer from './ContentLibraryReducer';
import reportingReducer from './ReportingReducer';
import offersReducer from './OffersReducer';
import vendorManagementReducer from './VendorManagementReducer';
import userManagementReducer from './UserManagementReducer';
import studentSummaryViewReducer from './StudentSummaryViewReducer';
import commonReducer from './CommonReducer';
import adminReducer from './AdminReducer';
import resourcesReducer from './ResourcesReducer';

const rootReducer = combineReducers({
    authenticationReducer,
    subscriberReducer,
    contentLibraryReducer,
    reportingReducer,
    offersReducer,
    vendorManagementReducer,
    userManagementReducer,
    studentSummaryViewReducer,
    commonReducer,
    adminReducer,
    resourcesReducer
});

export default rootReducer;
